import React, { useState, useEffect } from 'react';
import '../../styles/navbar.css'; 
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useDispatch, useSelector } from "react-redux";
import { setIsDark } from "../../redux/action";
import { Link } from 'react-scroll'
const Navbar = () => {
    const dispatch = useDispatch();
    const { isDark } = useSelector((state) => state.useReducer);
    const [isOpen, setIsOpen] = useState(false);
    const [Navbar, setNavbar] = useState(false)
    // theme toggle
    const getData = JSON.parse(localStorage.getItem("isDark"));
    useEffect(() => {
        if (getData) {
            dispatch(setIsDark(true));
        } else {
            dispatch(setIsDark(false));
        }
    }, [dispatch, getData]);
    const navToggle = () => {
        setIsOpen(!isOpen);
    };

    const toggleDarkMode = () => {
        if (getData) {
            localStorage.setItem("isDark", JSON.stringify(false));
            dispatch(setIsDark(false));
        } else {
            localStorage.setItem("isDark", JSON.stringify(true));
            dispatch(setIsDark(true));
        }
    };
    const changeBackground = () => {
        if (window.scrollY >= 150) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }
    window.addEventListener('scroll', changeBackground)
  
    return (
        <header className={`nav-header ${Navbar && "navbar-active"}`} style={{ backgroundColor: `${isDark ? "#070F2B" : "#fff"}` }}>
            <div className="nav-container">
                <div className="nav-data">
                    <div className="logo">
                        <Link style={{ color: `${isDark ? "#fff" : "#000"}` }} to="/" spy={true}
                            smooth={true}
                            offset={-100}
                            duration={500} className='logo-link'>Munesh Kumar</Link>
                    </div>

                    <nav className={`nav ${isOpen && 'open' }`}>
                        <ul>
                            <li><Link style={{ color: `${isDark ? "#fff" : "#000"}` }} to="/" spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500} className='nav-pages' activeClass="active" onClick={()=>setIsOpen(!isOpen)}>Home</Link></li>
                            <li><Link style={{ color: `${isDark ? "#fff" : "#000"}` }} to="about" spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500} className='nav-pages' activeClass="active" onClick={()=>setIsOpen(!isOpen)}>About</Link></li>
                            <li><Link style={{ color: `${isDark ? "#fff" : "#000"}` }} to="skill" spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500} className='nav-pages' activeClass="active" onClick={()=>setIsOpen(!isOpen)}>Skills</Link></li>
                            <li><Link style={{ color: `${isDark ? "#fff" : "#000"}` }} to="portfolio" spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500} className='nav-pages' activeClass="active" onClick={()=>setIsOpen(!isOpen)}>Portfolio</Link></li>
                            <li><Link style={{ color: `${isDark ? "#fff" : "#000"}` }} to="contact" spy={true}
                                smooth={true}
                                offset={-100}
                                duration={500} className='nav-pages' activeClass="active" onClick={()=>setIsOpen(!isOpen)}>Contact</Link></li>
                        </ul>
                    </nav>
                </div>
                <DarkModeSwitch
                    checked={!isDark}
                    onChange={toggleDarkMode}
                    size={37}
                    id='theme-toggle'
                />
                <button type="button" className={`nav-toggler ${isOpen ? 'active' : ''}`} onClick={navToggle}>
                    <span></span>
                </button>
            </div>
        </header>
    );
};

export default Navbar;
